import { Box, Card, Typography } from '@mui/material';
import { FC } from 'react';
import styles from './styles.module.scss';
import { Container, WithGradientedName } from '@/components';
import { Trans, useTranslation } from 'next-i18next';

export const InfoSection: FC = () => {
  const { t } = useTranslation('ourData');
  const config = [
    {
      titleKey: 'info.infoCard1.title',
      subtitle: t('info.infoCard1.subtitle'),
      description: t('info.infoCard1.description'),
    },
    {
      titleKey: 'info.infoCard2.title',
      subtitle: t('info.infoCard2.subtitle'),
      description: t('info.infoCard2.description'),
    },
    {
      titleKey: 'info.infoCard3.title',
      subtitle: t('info.infoCard3.subtitle'),
      description: t('info.infoCard3.description'),
    },
    {
      titleKey: 'info.infoCard4.title',
      subtitle: t('info.infoCard4.subtitle'),
      description: t('info.infoCard4.description'),
    },
  ];

  return (
    <Box component="section" className={styles.section}>
      <Container className={styles.container}>
        <Typography variant="h2" className={styles.title}>
          <WithGradientedName text={t('info.title')} lastLetterGradient />
        </Typography>
        <Box className={styles.sectionSubHead}>
          <Box className={styles.sectionSubHeadItem}>
            <Typography variant="h5">{t('info.benefit1')}</Typography>
          </Box>
          <Box className={styles.sectionSubHeadItem}>
            <Typography variant="h5">{t('info.benefit2')}</Typography>
          </Box>
          <Box className={styles.sectionSubHeadItem}>
            <Typography variant="h5">{t('info.benefit3')}</Typography>
          </Box>
        </Box>
        <Box className={styles.cards}>
          {config.map((item) => {
            return (
              <Card key={item.titleKey} className={styles.card}>
                <Typography className={styles.cardTitle}>
                  <Trans
                    components={{ s: <span className="pw-text-gradient" /> }}
                    ns="ourData"
                    i18nKey={item.titleKey}
                  />
                </Typography>
                <Typography variant="subtitle1" className={styles.cardSubTitle}>
                  {item.subtitle}
                </Typography>
                <Typography variant="subtitle2" className={styles.cardDescription}>
                  {item.description}
                </Typography>
              </Card>
            );
          })}
        </Box>
      </Container>
    </Box>
  );
};
